<template>
    <a-modal v-model:visible="props.visible" width="600px" @cancel="closePopup" :footer="null" :mask-closable="false">
        <a-row>
            <a-col :span="24">
                <a-form :model="formData" ref="formRef">
                    <a-row :gutter="{ xs: 8, sm: 10 }" class="input-container">
                        <a-col :xs="24" :sm="10" :md="9" :lg="9" class="field-v-center height-32">
                            <span class="left">{{ $t('discharge_business_operator') }}</span>
                            <span class="required-area">
                                <span class="required-label">
                                    {{ $t('required') }}
                                </span>
                            </span>
                        </a-col>

                        <a-col :xs="20" :sm="14" :md="15" :lg="15">
                            <a-row :gutter="{ xs: 8, sm: 10 }">
                                <a-col :xs="24" :sm="24" :md="24" :lg="24">
                                    <a-form-item ref="dischargerId" name="dischargerId"
                                        :rules="[{ required: true, message: t('MSG_00_21'), trigger: ['blur', 'change'] }]">
                                        <a-select v-model:value="formData.dischargerId" style="width: 100%"
                                            :disabled="selectedCompanyId !== 'ALL'">
                                            <a-select-option v-for="(item, index) in listCompany" :key="index" :value="item.value">
                                                {{ item.label }}
                                            </a-select-option>
                                        </a-select>
                                    </a-form-item>
                                </a-col>
                            </a-row>
                        </a-col>
                    </a-row>

                    <a-row :gutter="{ xs: 8, sm: 10 }" class="input-container">
                        <a-col :xs="24" :sm="10" :md="9" :lg="9" class="field-v-center height-32">
                            <span class="left">{{ $t('project_title') }}</span>
                            <span class="required-area">
                                <span class="required-label">
                                    {{ $t('required') }}
                                </span>
                            </span>
                        </a-col>

                        <a-col :xs="20" :sm="14" :md="15" :lg="15">
                            <a-row :gutter="{ xs: 8, sm: 10 }">
                                <a-col :xs="24" :sm="24" :md="24" :lg="24">
                                    <a-form-item ref="projectId" name="projectId"
                                        :rules="[{ required: true, message: t('MSG_00_21'), trigger: ['blur', 'change'] }]">
                                        <a-select v-model:value="formData.projectId" style="width: 100%" :disabled="formData.dischargerId === null">
                                            <a-select-option v-for="(item, index) in listProjectTitle" :key="index" :value="item.id">
                                                {{ item.projectTitle }}
                                            </a-select-option>
                                        </a-select>
                                    </a-form-item>
                                </a-col>
                            </a-row>
                        </a-col>
                    </a-row>

                    <a-row :gutter="{ xs: 8, sm: 10 }" class="input-container">
                        <a-col :xs="24" :sm="10" :md="9" :lg="9" class="field-v-center height-32">
                            <span class="left">{{ $t('collection_month_2') }}</span>
                            <span class="required-area">
                                <span class="required-label">
                                    {{ $t('required') }}
                                </span>
                            </span>
                        </a-col>

                        <a-col :xs="20" :sm="14" :md="15" :lg="15">
                            <a-row :gutter="{ xs: 8, sm: 10 }">
                                <a-col :xs="12" :sm="10" :md="10" :lg="10">
                                    <a-form-item ref="collectionMonth" name="collectionMonth"
                                        :rules="[{ required: true, message: t('MSG_00_21'), trigger: ['blur', 'change'] }]">
                                        <a-select v-model:value="formData.collectionMonth" :disabled="formData.projectId === null" @change="onChangeCollectionMonth">
                                            <a-select-option v-for="(item, index) in listCollectionMonth" :key="index" :value="item">
                                                {{ item }}
                                            </a-select-option>
                                        </a-select>
                                    </a-form-item>
                                </a-col>
                            </a-row>
                        </a-col>
                    </a-row>

                    <a-row :gutter="{ xs: 8, sm: 10 }" class="input-container">
                        <a-col :xs="24" :sm="10" :md="9" :lg="9" class="field-v-center height-32">
                            <span class="left">{{ $t('burnable_garbage') }}</span>
                        </a-col>

                        <a-col :xs="20" :sm="14" :md="15" :lg="15">
                            <a-row :gutter="{ xs: 8, sm: 10 }">
                                <a-col :xs="12" :sm="10" :md="10" :lg="10">
                                    <a-row :gutter="{ xs: 8, sm: 10 }">
                                        <a-col class="custom-message-error" :xs="19" :sm="19" :md="19" :lg="19">
                                            <a-form-item ref="burnableGarbageWeight" name="burnableGarbageWeight"
                                                :rules="[{ validator: validateWeight, trigger: ['blur', 'change'] }]">
                                                <VolumeInput v-model:value="formData.burnableGarbageWeight" class="input-right"
                                                    :disabled="formData.projectId === null ||
                                                        formData.collectionMonth === null ||
                                                        !isEnableInput(WASTE.WASTE_REGULAR_TYPE.BURNABLE_WASTE)" />
                                            </a-form-item>
                                        </a-col>
                                        <a-col class="padding-top5" :xs="5" :sm="5" :md="5" :lg="5">
                                            <span>kg</span>
                                        </a-col>
                                    </a-row>
                                </a-col>
                            </a-row>
                            <a-row class="error-message">
                                <span v-if="!burnableGarbageWeightValid">{{ t('MSG_00_27') }}</span>
                            </a-row>
                        </a-col>
                    </a-row>

                    <a-row :gutter="{ xs: 8, sm: 10 }" class="input-container">
                        <a-col :xs="24" :sm="10" :md="9" :lg="9" class="field-v-center height-32">
                            <span class="left">{{ $t('bottles_can_pet_bottles') }}</span>
                        </a-col>

                        <a-col :xs="20" :sm="14" :md="15" :lg="15">
                            <a-row :gutter="{ xs: 8, sm: 10 }">
                                <a-col :xs="12" :sm="10" :md="10" :lg="10">
                                    <a-row :gutter="{ xs: 8, sm: 10 }">
                                        <a-col class="custom-message-error" :xs="19" :sm="19" :md="19" :lg="19">
                                            <a-form-item ref="bottleWeight" name="bottleWeight"
                                                :rules="[{ validator: validateWeight, trigger: ['blur', 'change'] }]">
                                                <VolumeInput v-model:value="formData.bottleWeight" class="input-right"
                                                    :disabled="formData.projectId === null ||
                                                        formData.collectionMonth === null ||
                                                        !isEnableInput(WASTE.WASTE_REGULAR_TYPE.GLASS_BOTTLES)"/>
                                            </a-form-item>
                                        </a-col>
                                        <a-col class="padding-top5" :xs="5" :sm="5" :md="5" :lg="5">
                                            <span>kg</span>
                                        </a-col>
                                    </a-row>
                                </a-col>
                            </a-row>
                            <a-row class="error-message">
                                <span v-if="!bottleWeightValid">{{ t('MSG_00_27') }}</span>
                            </a-row>
                        </a-col>
                    </a-row>

                    <a-row :gutter="{ xs: 8, sm: 10 }" class="input-container">
                        <a-col :xs="24" :sm="10" :md="9" :lg="9" class="field-v-center height-32">
                            <span class="left">{{ $t('cardboard') }}</span>
                        </a-col>

                        <a-col :xs="20" :sm="14" :md="15" :lg="15">
                            <a-row :gutter="{ xs: 8, sm: 10 }">
                                <a-col :xs="12" :sm="10" :md="10" :lg="10">
                                    <a-row :gutter="{ xs: 8, sm: 10 }">
                                        <a-col class="custom-message-error" :xs="19" :sm="19" :md="19" :lg="19">
                                            <a-form-item ref="cardboardWeight" name="cardboardWeight"
                                                :rules="[{ validator: validateWeight, trigger: ['blur', 'change'] }]">
                                                <VolumeInput v-model:value="formData.cardboardWeight" class="input-right"
                                                    :disabled="formData.projectId === null ||
                                                        formData.collectionMonth === null ||
                                                        !isEnableInput(WASTE.WASTE_REGULAR_TYPE.CARDBOARD)" />
                                            </a-form-item>
                                        </a-col>
                                        <a-col class="padding-top5" :xs="5" :sm="5" :md="5" :lg="5">
                                            <span>kg</span>
                                        </a-col>
                                    </a-row>
                                </a-col>
                            </a-row>
                            <a-row class="error-message">
                                <span v-if="!cardboardWeightValid">{{ t('MSG_00_27') }}</span>
                            </a-row>
                        </a-col>
                    </a-row>

                    <a-form-item>
                        <a-row>
                            <a-col :xs="24" :sm="24" :md="24" :lg="24" class="bottom">
                                <a-form-item>
                                    <a-button type="primary" @click="report" :disabled="isDisableReport()">
                                        {{ $t('report') }}
                                    </a-button>
                                </a-form-item>
                            </a-col>
                        </a-row>
                    </a-form-item>
                </a-form>
            </a-col>
        </a-row>
        <template #title>
            <a-row>
                <a-col :xs="24" :sm="24" :md="24" :lg="24" class="header">
                    <span>{{ $t('report_complete_transport_waste') }}</span>
                </a-col>
            </a-row>
        </template>
    </a-modal>
</template>

<script setup lang="ts">
    import { ref, reactive, onMounted, watch } from 'vue';
    import { useI18n } from 'vue-i18n';
    import { Modal, message } from 'ant-design-vue';
    import AchievementService from '@/services/modules/AchievementService';
    import { WASTE, PROJECT } from '@/constants';
    import { useCommonStore } from '@/stores';
    import { storeToRefs } from 'pinia';
    import { formatModalTitle } from '@/utils/modules/message';
    import VolumeInput from './VolumeInput.vue';

    const props = defineProps({
        visible: {
            type: Boolean,
            default: false
        }
    });

    const emit = defineEmits(['close']);

    interface FormData {
        dischargerId: number | null;
        projectId: string | null;
        collectionMonth: string | null;
        burnableGarbageWeight: string;
        bottleWeight: string;
        cardboardWeight: string;
    }

    const formData = reactive<FormData>({
        dischargerId: null,
        projectId: null,
        collectionMonth: null,
        burnableGarbageWeight: '0.00',
        bottleWeight: '0.00',
        cardboardWeight: '0.00'
    });

    const listCompany = ref<any[]>([]);
    const listProjectTitle = ref<any[]>([]);
    const { t } = useI18n();
    const formRef = ref();
    const listCollectionMonth = ref<string[]>();
    const volumeInfo = ref();
    const burnableGarbageWeightValid = ref(true);
    const bottleWeightValid = ref(true);
    const cardboardWeightValid = ref(true);
    const commonStore = useCommonStore();
    const { selectedCompanyId } = storeToRefs(commonStore);

    watch(
        () => props.visible,
        async (val) => {
            if (val) {
                if (selectedCompanyId.value == 'ALL') {
                    listCompany.value = await AchievementService.getListCompanyForReport(PROJECT.TYPE.REGULAR);
                } else if (selectedCompanyId.value != null) {
                    formData.dischargerId = Number.parseInt(selectedCompanyId.value);
                    listProjectTitle.value = await AchievementService.getListProjectTitle(
                        PROJECT.TYPE.REGULAR,
                        selectedCompanyId.value
                    );
                    listCompany.value = commonStore.companyList;
                }
            }
        }
    );

    watch(
        () => formData.dischargerId,
        async (val) => {
            listProjectTitle.value = await AchievementService.getListProjectTitle(
                PROJECT.TYPE.REGULAR,
                val?.toString()
            );
            formData.projectId = null;
            formData.collectionMonth = null;
            resetInput();
        }
    );

    watch(
        () => formData.projectId,
        async (val) => {
            if (val == null) {
                return;
            }
            listCollectionMonth.value = await AchievementService.getListCollectionMonth(val);
            formData.collectionMonth = null;
            resetInput();
        }
    );

    const onChangeCollectionMonth = async (event: any, option: any) => {
        resetInput();
        await AchievementService.getVolumeInfo(
            formData.projectId,
            formData.collectionMonth
        ).then((res:any) => {
            volumeInfo.value = res;
            res.forEach((item: any) => {
                if (item.category == WASTE.WASTE_REGULAR_TYPE.BURNABLE_WASTE) {
                    formData.burnableGarbageWeight = AchievementService.convertWeight(item.volume);
                } else if (item.category == WASTE.WASTE_REGULAR_TYPE.GLASS_BOTTLES) {
                    formData.bottleWeight = AchievementService.convertWeight(item.volume);
                } else if (item.category == WASTE.WASTE_REGULAR_TYPE.CARDBOARD) {
                    formData.cardboardWeight = AchievementService.convertWeight(item.volume);
                }
            });
        });
    };

    const resetInput = () => {
        formData.burnableGarbageWeight = '0.00';
        formData.bottleWeight = '0.00';
        formData.cardboardWeight = '0.00';
        burnableGarbageWeightValid.value = true;
        bottleWeightValid.value = true;
        cardboardWeightValid.value = true;
        volumeInfo.value = undefined;
        formRef.value?.clearValidate();
    }

    const isEnableInput = (type: string) => {
        if (volumeInfo.value == null) {
            return false;
        }
        for (let i = 0; i < volumeInfo.value.length; i++) {
            if (volumeInfo.value[i].category == type) {
                return !volumeInfo.value[i].disabled;
            }
        }
    };

    const isDisableReport = () => {
        return (
            formData.projectId === null ||
            formData.collectionMonth === null ||
            volumeInfo.value == null ||
            volumeInfo.value.length == 0
        );
    };

    const report = async () => {
        try {
            await formRef.value?.validate();
            let modal = Modal.confirm({
                title: '',
                cancelText: t('yes'),
                cancelButtonProps: {
                    type: 'primary',
                    onClick: async () => {
                        let listVolume = [];
                        if (isEnableInput(WASTE.WASTE_REGULAR_TYPE.BURNABLE_WASTE)) {
                            listVolume.push({
                                volume: formData.burnableGarbageWeight?.replace(/,/g, ''),
                                category: WASTE.WASTE_REGULAR_TYPE.BURNABLE_WASTE
                            });
                        }
                        if (isEnableInput(WASTE.WASTE_REGULAR_TYPE.GLASS_BOTTLES)) {
                            listVolume.push({
                                volume: formData.bottleWeight?.replace(/,/g, ''),
                                category: WASTE.WASTE_REGULAR_TYPE.GLASS_BOTTLES
                            });
                        }

                        if (isEnableInput(WASTE.WASTE_REGULAR_TYPE.CARDBOARD)) {
                            listVolume.push({
                                volume: formData.cardboardWeight?.replace(/,/g, ''),
                                category: WASTE.WASTE_REGULAR_TYPE.CARDBOARD
                            });
                        }
                        AchievementService.reportCompleteTransportGeneralWaste({
                            projectId: formData.projectId,
                            year: formData.collectionMonth?.split('/')[0],
                            month: formData.collectionMonth?.split('/')[1],
                            listVolume: listVolume
                        })
                            .then(() => {
                                message.success({
                                    content: t('message_add_report_transport_general_waste_success'),
                                    duration: 5
                                });
                                closePopup(true);
                            })
                            .catch(() => {
                                message.error({
                                    content: t('message_add_report_transport_general_waste_fail'),
                                    duration: 5
                                });
                            });
                        modal.destroy();
                    }
                },
                okText: t('no'),
                okType: 'danger',
                centered: true,
                maskClosable: true,
                onOk() {
                    modal.destroy();
                }
            });
            const title = t('MSG_20_1');
            modal.update({
                title: formatModalTitle(title)
            });
        } catch (error) { }
    };

    const closePopup = (needUpdate: boolean | null) => {
        emit('close', needUpdate);
        formData.projectId = null;
        formData.collectionMonth = null;
        resetInput();
        formRef.value?.resetFields();
    };

    const validateWeight = async (validator: any, value: string) => {
        let valid = AchievementService.validateVolume(value);
        switch (validator.field) {
            case 'burnableGarbageWeight':
                burnableGarbageWeightValid.value = valid;
                break;
            case 'bottleWeight':
                bottleWeightValid.value = valid;
                break;
            case 'cardboardWeight':
                cardboardWeightValid.value = valid;
                break;
            default:
                break;
        }
        if (!valid) {
            return Promise.reject();
        }
        return Promise.resolve();
    };
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';

.header {
    text-align: center;
    color: #0083E9;
    font-size: 20px;
    border-bottom: 1px solid $gray-color;
    padding-bottom: 15px;
    margin-bottom: 10px;
}

.bottom {
    text-align: center;
    border-top: 1px solid $gray-color;
    padding-top: 20px;

    button {
        background-color: #4096ff;
        width: 120px;
    }
}

.input-container {
    margin-bottom: 10px;
}

.input-container:nth-child(n + 3) {
    margin-bottom: 0px;
}

.ant-form-item {
    margin-bottom: 0px;
    height: 54px;
}

.custom-message-error .ant-form-item {
    height: 32px;
}

.error-message {
    color: #f67e7e;
    height: 22px;
    margin-bottom: 5px;
}

input {
    text-align: right;
}

.padding-top5 {
    padding-top: 5px;
}

.field-v-center {
    align-content: center;
}

.height-32 {
    height: 32px;
}

.left {
    float: left;
}

.required-area {
    width: 40px;
    float: right;
    text-align: right;

    .required-label {
        background-color: $red-color;
        color: white;
        padding: 3px 5px;
        border-radius: 3px;
        font-size: 11px;
    }
}

@media (max-width: 574px) {
    .required-area {
        float: left;
    }
}

:deep(span.input-right input) {
    text-align: right;
}
</style>
